import React from "react"
import { AlertTriangle, Chrome } from "lucide-react"
import { Button } from "./button"

export function BrowserCheckFallback() {
  const handleDownloadChrome = () => {
    try {
      window.open('https://www.google.com/chrome/', '_blank')
    } catch (error) {
      console.error('Failed to open Chrome download:', error)
      // Fallback: set window location
      window.location.href = 'https://www.google.com/chrome/'
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <AlertTriangle className="w-16 h-16 mx-auto text-orange-500 mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Chrome Required for this Interview
          </h1>
          <p className="text-gray-600">
          For the best experience and full compatibility during this interview, 
          please switch to Google Chrome from your current browser.
          </p>
        </div>

        <div className="bg-blue-50 rounded-lg p-4 mb-6">
          <h2 className="font-semibold text-lg mb-2 text-gray-900 flex items-center justify-center gap-2">
            <Chrome className="h-5 w-5 text-blue-600" />
            Download Chrome
          </h2>
          <p className="text-sm text-gray-600 mb-3">
            Download and install Google Chrome to continue
          </p>
          <Button 
            onClick={handleDownloadChrome} 
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white mx-auto"
          >
            <Chrome className="h-4 w-4" />
            Download Chrome
          </Button>
        </div>

        <div className="mt-6 pt-4 border-t">
          <p className="text-xs text-gray-500">
            Please use a desktop or laptop with Google Chrome for video interviews
          </p>
        </div>
      </div>
    </div>
  )
}